import { parseQueryString, replaceQueryString } from "@client/lib/api";
import { getActualHeight, getActualWidth, parseValue } from "@client/lib/values/size";

const CSS_FIT_TO_UNSPLASH_FIT = {
  unset: "scale",
  contain: "clip",
  cover: "crop",
  fill: "scale",
  "scale-down": "clip"
};
export const setSizeToMediaUrl = (url: string, size: string, fit?: string) => {
  if (size && url.startsWith("https://images.unsplash.com")) {
    const parsedSize = parseValue(size);
    const qs = parseQueryString(url) || {};
    qs["fit"] = fit ? CSS_FIT_TO_UNSPLASH_FIT[fit] : "crop";
    qs["crop"] = qs["fit"] === "crop" ? "h" : undefined;
    qs["w"] = getActualWidth(parsedSize);
    qs["h"] = getActualHeight(parsedSize);
    return replaceQueryString(url, qs);
  }
  return url;
};
